'use strict';

function parseFloatInput( stringValue, defaultValue ) {

    if (stringValue == undefined) {
        return defaultValue;
    }
    if (defaultValue != undefined && stringValue === '') {
        return defaultValue;
    }
    if (typeof stringValue == 'number') {
        return stringValue;
    }

    if (!stringValue.replace) {
        return defaultValue;
    }

    let s = stringValue.replace(',','.').trim();

    if (s.indexOf && s.indexOf('.') === -1) {
        return parseInt( s );
    }

    return parseFloat( s );
}

function floatToInput( floatValue, precision ) {
    if (!floatValue) {
        return floatValue;
    }
    if (!floatValue.toFixed) {
        return floatValue;
    }
    return parseFloat( floatValue.toFixed( precision || 4 ) );
}

function floatToAnim( floatValue, precision ) {
    if (!floatValue.toFixed) {
        return floatValue;
    }
    return parseFloat( floatValue.toFixed( precision || 6 ) );
}

function timeFactorFromInputSpeed( stringValue ) {
    let speed = parseFloatInput( stringValue );
    if (isNaN( speed )) {
        speed = 0;
    }

    if (speed > 0) {
        // ja ir 1, tad ātrumam jābūt 0.5 - 2reiz ātrāks;    1/2
        // ja ir 2, tad ātrumam jābūt 0.333 - 3 reiz ātrāks;    1/3
        // ja ir 5, tad ātrumam jābūt 0.166 - 3 reiz ātrāks;    1/6
        // ja ir 0.5, tad ātrumam jābūt uz pusi ātrākam; 0.75
        // ja ir <1, tad ātrumam jābūt lielākam par 0.5
        if (speed < 1) {
            return 1 - (speed / 2);
        }

        return 1 / (speed + 1);
    }
    if (speed < 0) {
        // ja ir -1, tad ātrumam jābūt 2 - 2reiz lēnāks;
        // ja ir -2, tad ātrumam jābūt 3 - 3 reiz lēnāks;
        // ja ir -0.5, tad ātrumam jābūt uz pusi lēnākam; 1.5

        return 1 + Math.abs( speed );
    }

    return 1;
}


var loadingSet = function( conf ) {

    this.conf = conf || {};

    this.on();
};

loadingSet.prototype.on = function() {

    this.toggleClass( true );

    return this;
};

loadingSet.prototype.off = function() {

    this.toggleClass( false );

    return this;
}

loadingSet.prototype.toggleClass = function( on ) {
    $( 'body' ).toggleClass( this.conf.bodyClass || 'gl-wait', on );

    if (this.conf.button) {
        $( this.conf.button ).toggleClass( this.conf.buttonClass || 'bt-loading', on );
    }

    return this;
};

loadingSet.prototype.success = function( on ) {
    const self = this;

    if (this.conf.button) {
        $( this.conf.button ).toggleClass( this.conf.successClass || 'bt-success', on );

        if (on) {
            setTimeout( function() {
                self.success( false );
            }, this.conf.successTimer || 4000 );
        }
    }

    return this;
};


function prevFind( $prev, selector, not ) {
    // $prev = $( el ).prev()
    if ($prev.length == 0) {
        return $();
    }
    if (not ? !$prev.is( selector ) : $prev.is( selector )) {
        return $prev;
    }

    return prevFind( $prev.prev(), selector, not );
}

function nextFind( $next, selector, not ) {
    // $next = $( el ).next()
    if ($next.length == 0) {
        return $();
    }
    if (not ? !$next.is( selector ) : $next.is( selector ) == 0) {
        return $next;
    }

    return nextFind( $next.next(), selector, not );
}



var fpsCounter = function( $elFps, $elMin, $elMax, $elAvg, interval, skipFirst, decimal ) {
    var self = this;

    this.$elFps = $elFps;
    this.$elMin = $elMin;
    this.$elMax = $elMax;
    this.$elAvg = $elAvg;
    this.interval = interval || 300;
    this.skipFirst = skipFirst || 4;
    this.decimal = decimal || 1;
    this.minFrameTime = 5;


    this.fps = {
        min: 0,
        max: 0,
        avg: 0
    };
    this.intervalCounter = 0;
    this.frameCounter = 0;

    this.avgInterval = [];
    this.avgAll = [];
    this.avgPrev = 0;
    this.avgNow = 0;

    this.lastStep = new Date;
    this.thisStep = null;


};

fpsCounter.prototype.start = function() {
    this.fps = {
        current: 0,
        min: null,
        max: 0,
        avg: 0
    };

    this.avgInterval = [];
    this.avgAll = [];

    this.lastStep = new Date;
    this.thisStep = null;
};

fpsCounter.prototype.step = function() {
    this.frameTime = (this.thisStep = new Date) - this.lastStep;
    if (this.frameTime < this.minFrameTime) {
        return;
    }
    this.lastStep = this.thisStep;
    ++this.frameCounter;

    if (this.frameCounter < this.skipFirst) {
        return;
    }

    this.fps.current = 1000 / this.frameTime;

    this.avgInterval.push( this.fps.current );

    if (!this.fps.min) this.fps.min = this.fps.current;
    else if (this.fps.current < this.fps.min) this.fps.min = this.fps.current;

    if (this.fps.current > this.fps.max) this.fps.max = this.fps.current;

    this.intervalCounter += this.frameTime;
    if (this.intervalCounter > this.interval) {
        this.intervalCounter = 0;

        this.avgPrev = this.avgNow;
        this.avgNow = this.avg(this.avgInterval);
        this.avgAll.push( this.avgNow );

        //console.log('FPS: avg ' + this.avg(this.avgInterval).toFixed(1) + '; min ' + this.fps.min.toFixed(1) + '; max ' + this.fps.max.toFixed(1) + '; ');
        this.$elFps.html( this.avgNow.toFixed( this.decimal ) );
        this.$elMin.html( this.fps.min.toFixed( this.decimal ) );
        this.$elMax.html( this.fps.max.toFixed( this.decimal ) );
        //this.$elAvg.html( ((this.avgPrev + this.avgNow) / 2).toFixed( this.decimal ) );
        this.$elAvg.html( this.avg(this.avgAll).toFixed( this.decimal ) );
        this.avgInterval = [];
        if (this.avgAll.length > 100) {
            this.avgAll = [];
            this.avgAll.push( this.avgNow );
        }
    }

    //frameTime+= (this.frameTime - frameTime) / 20;
    //console.log( this.frameTime, (this.fps.current).toFixed(1) + " fps" );
    /* if (this.fps.current > 100) {
        console.log( this.frameTime, (this.fps.current).toFixed(1) + " fps" );
    } */
    //return this.frameTime;
};

fpsCounter.prototype.finish = function() {
    this.$elFps.html( this.avg(this.avgInterval).toFixed( this.decimal ) );
    this.$elMin.html( this.fps.min.toFixed( this.decimal ) );
    this.$elMax.html( this.fps.max.toFixed( this.decimal ) );
    this.$elAvg.html( this.fps.max.toFixed( this.decimal ) );
};

fpsCounter.prototype.avg = function( array ) {
    if (array.length === 0) return 0;
    return array.reduce((s, a) => s + a, 0) / array.length;
};

window.parseFloatInput = parseFloatInput;
window.floatToInput = floatToInput;
window.floatToAnim = floatToAnim;
window.timeFactorFromInputSpeed = timeFactorFromInputSpeed;
window.fpsCounter = fpsCounter;